import {
  deleteAuthorizationHeader,
  getResData,
  httpClient,
} from "utils";

import { DOCUMENTS_API_PATHS } from "./consts";
import {
  ApprovalsRequestBody,
  CreateBillInDocumentDTO,
  DocumentByIdDTO,
  DocumentsDTO,
  DocumentsQuery,
  PDFDocumentToS3,
} from "./types";

export const createDocuments = ({
  fileNames,
  siteId,
}: {
  fileNames: string[];
  siteId: number;
}) =>
  httpClient
    .post(
      DOCUMENTS_API_PATHS.DOCUMENTS(),
      fileNames.map((filename) => ({ filename, siteId })),
    )
    .then(getResData);

export const createComanDocuments = ({
  filename,
  billGuid,

}: {
  filename: string;
  billGuid: string;
}) =>
  httpClient
    .post(
      DOCUMENTS_API_PATHS.COMANDOCUMENTS(),
      { filename, billGuid }
    )
    .then(getResData);

export const documentUploaded = (document: PDFDocumentToS3) =>
  httpClient.post(DOCUMENTS_API_PATHS.DOCUMENTS_UPLOADED, [document]);

export const comandocumentUploaded = (documentUuid: string) =>
  httpClient.post(DOCUMENTS_API_PATHS.COMANDOCUMENTS_UPLOADED, { documentUuid });

export const uploadDocumentToS3 = ({
  url,
  file,
}: {
  url: string;
  file: File;
}) =>
  httpClient.put(url, file, {
    headers: {
      "Content-Type": file.type,
    },
    transformRequest: deleteAuthorizationHeader,
  });

export const getDocuments = (query: DocumentsQuery): Promise<DocumentsDTO> =>
  httpClient
    .get<DocumentsDTO>(DOCUMENTS_API_PATHS.DOCUMENTS(query))
    .then(getResData);

export const deleteDocument = (documentId: string) =>
  httpClient.delete(DOCUMENTS_API_PATHS.DOCUMENT(documentId));


export const downloadDocuments = (documentIds: string[]) =>
  httpClient.post(DOCUMENTS_API_PATHS.EXPORT_DOCUMENTS, documentIds, { responseType: "blob" },);

export const getDocumentById = (documentId: string) =>
  httpClient
    .get<DocumentByIdDTO>(DOCUMENTS_API_PATHS.DOCUMENT(documentId))
    .then(getResData);

export const createBillInDocument = ({
  documentId,
  body,
}: {
  documentId: string;
  body: CreateBillInDocumentDTO;
}) =>
  httpClient
    .post(DOCUMENTS_API_PATHS.CREATE_BILL(documentId), body)
    .then(getResData);

export const getDocumentBills = (documentId: string) =>
  httpClient
    .get<any>(DOCUMENTS_API_PATHS.GET_BILLS(documentId))
    .then(getResData);

export const getApprovalDATA = ({ startDatePayload, endDatePayload }: any) =>
  httpClient.get(`${DOCUMENTS_API_PATHS.DOCUMENT_APPROVAL}?startDate=${startDatePayload}&endDate=${endDatePayload}`);

export const getApprovalDATAById = (id: any) =>
  httpClient.get(DOCUMENTS_API_PATHS.DOCUMENT_APPROVAL_BY_ID(id));

export const getApprovalBillData = (body: ApprovalsRequestBody) =>
  httpClient.post(DOCUMENTS_API_PATHS.APPROVAL_BILL_DATA, body);

export const getLockedBillData = (body: ApprovalsRequestBody) =>
  httpClient.post(DOCUMENTS_API_PATHS.APPROVAL_BILL_LOCK_DATA, body);

export const getApprovalSignOff = (payload: ApprovalsRequestBody) =>
  httpClient.post(DOCUMENTS_API_PATHS.APPROVAL_SIGNOFF, payload);

export const undoApprovalSignOff = (payload: any) =>
  httpClient.delete(`${DOCUMENTS_API_PATHS.APPROVAL_SIGNOFF}?approvalIds=${payload}`);

export const getApprovalLock = (payload: any) =>
  httpClient.post(DOCUMENTS_API_PATHS.APPROVAL_LOCK, payload);

export const undoApprovalLock = (payload: any) =>
  httpClient.delete(`${DOCUMENTS_API_PATHS.APPROVAL_LOCK}?approvalIds=${payload}`);
